import { TipoCertificacaoEnum } from 'enums/TipoCertificacaoEnum';
import { jsonProperty, Serializable } from 'ts-serializable';

export class CertificacoesModel extends Serializable {
    @jsonProperty(Number, null)
    codigo: number | null = -1;

    @jsonProperty(String)
    nome: string = '';

    @jsonProperty(String, null)
    textoSolicitacao: string | null = null;

    @jsonProperty(Boolean)
    precisaSolicitar: boolean = true;

    @jsonProperty(String, null)
    link: string | null = null;

    @jsonProperty(Boolean)
    certificateTemplateInternal: boolean = false;

    @jsonProperty(String)
    filepathCapa: string = '';

    @jsonProperty(String)
    filepathVerso: string = '';

    @jsonProperty(String)
    type: TipoCertificacaoEnum = TipoCertificacaoEnum.RECURSO;

    @jsonProperty(Number)
    cargaHoraria: number = 0;

    @jsonProperty(String)
    base64Capa: string = '';

    @jsonProperty(String)
    base64Verso: string = '';

    @jsonProperty(Number)
    ferramentaAutoriaCursoCodigo: number = 0;

    @jsonProperty(Number)
    itemRecursoCustomizadoCodigo: number = 0;
}
